<template>
  <v-container fluid class="px-0"> </v-container>
</template>

<script>
export default {
  name: 'TurtasKitas',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
}
</script>
